import {
	booleanAttribute,
	Component,
	EventEmitter,
	Input,
	Output,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { InvitePrepComponent } from "@app/invite-prep/invite-prep.component"

@Component({
	selector: "app-gen-table-modal-input",
	imports: [COMMON_IMPORTS, ModalWrapComponent, InvitePrepComponent],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<button
			class="btn btn-icon"
			(click)="open()"
		>
			<app-icon
				[icon]="attrs.icon"
				[isImg]="attrs.isImg"
			/>
		</button>
		@switch (modalProps?.name) {
			@case ("invite-prep") {
				<app-modal-wrap (onClose)="modalProps = null">
					<app-invite-prep
						(onClose)="modalProps = null; handleClose($event)"
						[state]="value"
					/>
				</app-modal-wrap>
			}
		}
	`,
})
export class GenTableModalInputComponent {
	modalProps: any = null
	@Output() onChange = new EventEmitter()
	@Input() value: any = null
	@Input() attrs: any = null

	handleClose(ret: any = null) {
		ret && this.onChange.emit(ret)
	}
	open() {
		const { modal } = this.attrs
		switch (modal) {
			case "invite-prep": {
				this.modalProps = { name: modal }
				return
			}
		}
	}
}
